import axios from "axios";

export const SINADICCIONES_BASE = "https://sinadicciones.org";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// We proxy sinadicciones.org read-only endpoints through our backend to avoid
// missing CORS headers on the upstream API.
export const PROXY_API = `${BACKEND_URL}/api/proxy`;
export const UPLOADS_PROXY = `${BACKEND_URL}/api/uploads`;

export const api = axios.create({
    baseURL: PROXY_API,
    timeout: 20000,
});

/**
 * Convert a relative /api/uploads/... path from sinadicciones.org
 * into a full HTTPS url usable from any domain. We route uploads through
 * our backend proxy so the browser can fetch them without CORS issues.
 */
export function getImageUrl(url) {
    if (!url) return null;
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/uploads/")) {
        return `${BACKEND_URL}${url}`;
    }
    if (url.startsWith("/api/")) return `${SINADICCIONES_BASE}${url}`;
    if (url.startsWith("/")) return `${SINADICCIONES_BASE}${url}`;
    return url;
}

export async function fetchCenters(params = {}, config = {}) {
    const { data } = await api.get("/centers/public", { params, ...config });
    return data;
}

export async function fetchCenterById(id) {
    const { data } = await api.get(`/centers/public/${id}`);
    return data;
}

export function formatPriceCLP(value) {
    if (value === null || value === undefined || value === 0) return null;
    return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        maximumFractionDigits: 0,
    }).format(value);
}

export function formatPriceRange(min, max) {
    const hasMin = !!min && min > 0;
    const hasMax = !!max && max > 0;
    if (!hasMin && !hasMax) return "Consultar";
    if (hasMin && hasMax) return `${formatPriceCLP(min)} - ${formatPriceCLP(max)}`;
    if (hasMin) return `Desde ${formatPriceCLP(min)}`;
    return `Hasta ${formatPriceCLP(max)}`;
}

export const CHILE_REGIONS = [
    "Arica y Parinacota",
    "Tarapacá",
    "Antofagasta",
    "Atacama",
    "Coquimbo",
    "Valparaíso",
    "Metropolitana",
    "O'Higgins",
    "Maule",
    "Ñuble",
    "Biobío",
    "Araucanía",
    "Los Ríos",
    "Los Lagos",
    "Aysén",
    "Magallanes",
];

export const MODALITIES = ["Residencial", "Ambulatorio", "Online", "Mixto"];
export const GENDERS = [
    { value: "mixto", label: "Mixto" },
    { value: "hombre", label: "Solo hombres" },
    { value: "mujer", label: "Solo mujeres" },
];
